var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('div',{staticClass:"hs-container-child"},[_c('c-header',{attrs:{"title":_vm.title,"leftIcon1":"return.png","leftFn1":_vm.close}}),_c('div',{staticClass:"details"},[_c('iframe',{key:_vm.url,attrs:{"width":"100%","height":"100%","src":_vm.url}})])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }